import axios from 'axios';

import { TokenManager } from '../../auth/TokenManager';
import AppSettings from '../../constants';
import { Offer } from '../model/offer.model';
import { OfferModel } from '../model/OfferModel';

interface GetOfferAndApprovalRequestsByIdParams {
    offerId: string;
    token: string;
}

interface GetOfferAndApprovalRequestsByIdResponse {
    offers: Offer[];
    approvalRequests: any[];
}

interface UpdateApprovalRequestParams {
    approvalRequestId: string;
    approvalRequest: any;
    token: string;
}

interface GetApprovalRequestsByEmailAndStateResponse {
    offers: OfferModel[];
    approvalRequests: any[];
}

export const getOfferAndApprovalRequestsById = ({
    offerId,
    token,
}: GetOfferAndApprovalRequestsByIdParams): Promise<GetOfferAndApprovalRequestsByIdResponse> => {
    return axios
        .get(AppSettings.routes.gateway + `/v1/offer/approval-requests?offerIds=${offerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            return {
                offers: response.data.offers.map((offer: any) => new Offer(offer)),
                approvalRequests: response.data.approvalRequests,
            };
        });
};

export const updateApprovalRequest = ({
    approvalRequestId,
    approvalRequest,
    token,
}: UpdateApprovalRequestParams): Promise<any> => {
    return axios
        .put(`${AppSettings.routes.api}/v1/offer/approval-requests/${approvalRequestId}`, approvalRequest, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => response.data);
};

export const getApprovalRequestsByEmailAndState = async (
    emailAddress: string,
    state: string
): Promise<GetApprovalRequestsByEmailAndStateResponse> => {
    const token = await TokenManager.getInstance().getToken();

    return axios
        .get(`${AppSettings.routes.gateway}/v1/offer/approval-requests`, {
            params: {
                emailAddresses: emailAddress,
                states: state,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            return {
                offers: (response.data.offers || []).map((offer: any) => new Offer(offer)),
                approvalRequests: response.data.approvalRequests || [],
            };
        });
};
